import React, { useEffect, useRef, useState } from "react";
import OtpInput from "react-otp-input";
import Layout from "../../../components/layout/Layout";
import Validator from "simple-react-validator"
import { URadio } from "ubs-framework";
import { useDispatch, useSelector } from "react-redux";
import { useForceUpdate } from "ubs-framework/src/hooks/useForceUpdate";
import { detectDevice, isElectron, showToastSuccess } from "ubs-framework/v2/common/function";
import useSocket from "../../common/useSocket";
import { sendData } from "../../../store/actions";
import * as Icon from "ubs-icons";
import { useHistory } from "react-router-dom";
import { checkCookie, getCookie } from "ubs-framework/v2/common/cookie";
import AppHeader from "../../common/components/app-header";
import {withRouter} from "../../../common/hocs/routing-hoc";

let interval = null
const OTP_TIMEOUT = 30;

const MultiFactorAuthenticate = (props) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const _LID = useSelector(e => e?.common?.logInDetails)
    const forceUpdate = useForceUpdate()
    const [otp, setOTP] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [seconds, setSeconds] = useState(0);
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [MFADetails, setMFADetails] = useState({
        isFirstOTP: true,
        MFAType: 1,
        isEmailMFA: false,
        isAuthenticatorAppMFA: false
    });
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));
    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'login':
                    if (res.data.aftrp) history.push("/change-password")
                    else if (res.data.activateAccount) history.push("/verify-email")
                    else if (res?.data?.isMultiFactorAuth && !res?.data?.token) {
                        setDisabledBtn(false)
                        setSeconds(OTP_TIMEOUT)
                        setMFADetails({
                            ...MFADetails,
                            email: res?.data?.email,
                            MFAType: res?.data?.MFAType ?? (!res?.data?.isEmailMFA && res?.data?.isAuthenticatorAppMFA ? 2 : 1),
                            isEmailMFA: res?.data?.isEmailMFA,
                            isAuthenticatorAppMFA: res?.data?.isAuthenticatorAppMFA,
                        })
                    } 
                    else if (checkCookie('previousURL')) window.location.href = getCookie('previousURL')
                    else {
                        setDisabledBtn(true)
                        history.push("/workspace")
                    }
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res.data.error)
            setDisabledBtn(false)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
            if (res?.data?.isMultiFactorAuth) {
                setMFADetails({
                    ...MFADetails,
                    email: res?.data?.email,
                    MFAType: res?.data?.MFAType ?? (!res?.data?.isEmailMFA && res?.data?.isAuthenticatorAppMFA ? 2 : 1),
                    isEmailMFA: res?.data?.isEmailMFA,
                    isAuthenticatorAppMFA: res?.data?.isAuthenticatorAppMFA,
                })
            }
        }
    })

    const onSubmit = (data) => {
        data.preventDefault()
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            dispatch({ type: 'SET_EMAIL', payload: data });
            const logInDetails = JSON.parse(JSON.stringify(_LID))
            const requestData = {
                email: logInDetails?.identifier,
                password: logInDetails?.password,
                platform: detectDevice(true),
            }
            requestData.otp = otp
            if (isElectron()) requestData.appVersion = window?.electron?.remote?.app?.getVersion();
            if (MFADetails?.isEmailMFA || MFADetails?.isAuthenticatorAppMFA) requestData.MFAType = MFADetails?.MFAType
            sendData(dispatch, 'login', requestData);
        } else {
            validator?.current?.showMessages()
        }
    }

    useEffect(() => {
        refresh()
        return () => off()
    }, [MFADetails])

    const resendOTP = (data) => {
        data.preventDefault()
        if (_LID?.identifier && _LID?.password) {
            setDisabledBtn(true)
            const logInDetails = JSON.parse(JSON.stringify(_LID))
            const requestData = {
                email: logInDetails?.identifier,
                password: logInDetails?.password,
                platform: detectDevice(true),
                MFAType: MFADetails?.MFAType,
            }
            sendData(dispatch, 'login', requestData);
            showToastSuccess("OTP sent successfully.")
            setMFADetails({...MFADetails, isFirstOTP: false})
        } else {
            validator?.current?.showMessages()
        }
    }

    const handle = {
        radioBtn: (e) => {
            setMFADetails({ ...MFADetails, MFAType: e })
        }
    }

    useEffect(() => {
        if(!_LID?.identifier || !_LID?.password) {
            history.push('/login')
        } else {
            setMFADetails({
                ...MFADetails,
                MFAType: _LID?.MFAType ?? (!_LID?.isEmailMFA && _LID?.isAuthenticatorAppMFA ? 2 : 1),
                isEmailMFA: _LID?.isEmailMFA,
                isAuthenticatorAppMFA: _LID?.isAuthenticatorAppMFA,
            })
        }
    }, [_LID])    

    useEffect(() => {
        if (seconds === OTP_TIMEOUT) {
            clearInterval(interval)
            interval = setInterval(() => {
                setSeconds(prevState => {
                    if (prevState === 1) {
                        clearInterval(interval)
                        return 0
                    } else return prevState - 1
                })
            }, 1000)
        }
    }, [seconds]);

    return (
        <Layout module="multiFactorAuthenticate">
            <div className="u_account-form">
                <AppHeader header="Multi-Factor Authentication"/>
                {((MFADetails?.isEmailMFA && MFADetails?.isAuthenticatorAppMFA)) && <div className='u_flex u_flex-wrap u_mt-24'>
                    <URadio
                        id="MFAType-workEmail"
                        name="MFAType"
                        label="Verify with Work Email"
                        htmlFor="MFAType-workEmail"
                        onChange={e => handle.radioBtn(1)}
                        checked={MFADetails?.MFAType === 1}
                        className="u_mr-15 u_mb-15"
                    />
                    <URadio
                        id="MFAType-twoFactorAuth"
                        name="MFAType"
                        label="Verify with Google Authenticator App"
                        htmlFor="MFAType-twoFactorAuth"
                        onChange={e => handle.radioBtn(2)}
                        checked={MFADetails?.MFAType === 2}
                        className="u_mb-15"
                    />
                </div>}
                {(MFADetails?.isFirstOTP && MFADetails?.MFAType === 1) && <p className={`u_cp u_blue u_small-font ${(MFADetails?.isEmailMFA && MFADetails?.isAuthenticatorAppMFA) ? '' : 'u_mt-24'}`} onClick={e => resendOTP(e, true)}>Send OTP?</p>}
                <div className={`u_otp u_mt-15 ${errorMsg ? 'u_mb-15' : 'u_mb-30'}`}>
                    <p className="u_mb-15 u_section-text">A six-digit OTP has been sent to your {MFADetails?.MFAType === 1 ? "work email" : "authenticator app"} for verification.</p>
                    <OtpInput
                        value={otp}
                        onChange={(e) => setOTP(e)}
                        isInputNum={true}
                        containerStyle={'u_otp-container'}
                        inputStyle={'u_otp-input'}
                        numInputs={6}
                        shouldAutoFocus={true}
                        separator={<span> </span>}
                    />
                    {MFADetails?.MFAType === 1 && !MFADetails?.isFirstOTP && <p className="u_mt-10 u_section-text">Didn't you receive the OTP? {seconds === 0 ?
                        <span className="u_cp u_blue" onClick={e => resendOTP(e, true)}>Resend OTP</span> : `${seconds} Seconds`}</p>}
                </div>
                {errorMsg.length !== 0 && <p className="u_error-message">{errorMsg}</p>}
                <p className="u_error-message">{validator?.current?.message("otp", otp, "required|min:6")}</p>
                <div className="u_block u_relative">
                    <button disabled={disabledBtn} type="button" onClick={onSubmit} className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}>Login</button>
                    {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                </div>
            </div>
        </Layout>
    )
}

export default withRouter(MultiFactorAuthenticate);
